import { DataSource } from 'src/constants';

export const saveable = <T extends Models.V3.SourcedBase>(x: T): boolean => (
    x.source === DataSource.Saved || x.source === DataSource.Selected
);
